import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import RadioButtonsGroup from "./Common/CustomRadio";
import { directiontypesData, graphtypesData } from "../data/assetsData";
import CustomInput from "./Common/CustomInput";
import CustomButton from "./Common/CustomButton";
import { GraphContext, GraphDispatchContext } from "../context";
import Graph, {
  GenerateRandom,
  generateRandom,
} from "../helpers/generateRandomNode";
import BestFirstSearch from "../helpers/Bfs";

function OptionsComponent() {
  const {
    setGraphType,
    graphOptions,
    setGraphConnection,
    setNumNodes,
    setStartNode,
    setGoalNode,
    setEdges,
    setNodes,
    nodes,
    edges,
    finalPath,
    onGenerateHuristic,
    reset,
  } = React.useContext(GraphContext);
  const { type, connection, inputField, isHuresticDisable } = graphOptions;
  const { numNodes, startNode, goalNode } = inputField;
  console.log(isHuresticDisable);
  const onHandleGenerateGraph = () => {
    const numberOfNode = parseInt(numNodes);
    if (numberOfNode > 30) alert("Please enter a number between 1 and 30.");
    else {
      GenerateRandom(numberOfNode, setNodes, setEdges, connection);
    }
  };
  const onHandleChange = (event, Title) => {
    const { value } = event.target;
    switch (Title) {
      case "Create Graph":
        setGraphType(value);
        break;
      default:
        setGraphConnection(value);
        break;
    }
  };
  const onhandleInputChange = (event) => {
    const { value, name } = event.target;

    switch (name) {
      case "starting":
        {
          setStartNode(value.toUpperCase());
        }
        break;
      case "ending":
        {
          setGoalNode(value.toUpperCase());
        }
        break;

      default:
        {
          setNumNodes(value);
        }
        break;
    }
  };

  return (
    <Grid
      style={{
        flex: 0.2,
        backgroundColor: "#0f1629",
        height: "100vh",
        borderRightWidth: 2,
        borderRightColor: "black",
        paddingBlock: 10,
      }}
    >
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid sx={{ alignItems: "flex-start" }}>
          <RadioButtonsGroup
            onChange={onHandleChange}
            Title={""}
            data={directiontypesData}
            value={connection}
          />
          <RadioButtonsGroup
            onChange={onHandleChange}
            Title={"Create Graph"}
            data={graphtypesData}
            value={type}
          />
        </Grid>
        {type !== "Custom" && (
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Grid width={"100%"}>
              <Typography
                color={"#ffffff98"}
                fontWeight={"bold"}
                marginLeft={1}
              >
                Number of nodes:
              </Typography>
            </Grid>
            <Grid
              display={"flex"}
              alignItems={"flex-start"}
              margin={1}
              justifyContent={"space-evenly"}
            >
              <CustomInput
                name={"totalNumber"}
                onChange={onhandleInputChange}
                value={numNodes}
                isNumberInput
              />
              <CustomButton
                onClick={onHandleGenerateGraph}
                lable="Generate Graph"
                varient={"contained"}
                isDisabled={numNodes === ""}
              />
              <CustomButton
                onClick={onGenerateHuristic}
                lable={"Add Heuristic"}
                varient={"contained"}
                isDisabled={numNodes === ""}
              />
            </Grid>
          </Grid>
        )}
        <Grid display="flex" alignItems={"center"}>
          <Grid
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-evenly"}
          >
            <Grid
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <Typography color={"white"} marginLeft={"6px"}>
                Start
              </Typography>
              <CustomInput
                onChange={onhandleInputChange}
                name={"starting"}
                isSmall
                value={startNode}
              />
            </Grid>
            <Grid
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <Typography color={"white"} marginLeft={"6px"}>
                Goal{" "}
              </Typography>
              <CustomInput
                onChange={onhandleInputChange}
                name={"ending"}
                isSmall
                value={goalNode}
              />
            </Grid>
            <BestFirstSearch />
            <Grid style={{ marginTop: 13 }}>
              <CustomButton
                lable={"Reset"}
                varient={"contained"}
                onClick={() => reset()}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default OptionsComponent;
